var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3749 13.3787C22.0566 10.2501 18.4932 7.68714 14.42 7.65414C10.3461 7.6205 7.30301 10.1285 7.62265 13.2583C7.94295 16.3856 11.5037 18.9486 15.5782 18.9822C19.6528 19.0165 22.6952 16.5066 22.3749 13.3787ZM8.90005 12.5951C8.62117 10.0735 11.2676 8.04882 14.807 8.07729C18.3445 8.10512 21.4407 10.1712 21.7176 12.6915C21.9946 15.2137 19.3513 17.2383 15.8106 17.2118C12.2732 17.184 9.17764 15.1186 8.90005 12.5951Z",
    fill: "#F8A883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7914 12.1635C6.46004 14.6016 6.42187 18.3487 8.70598 20.5371C10.9901 22.7248 14.7353 22.5216 17.0679 20.0855C19.4006 17.6499 19.4368 13.9015 17.1527 11.7119C14.8699 9.52416 11.1253 9.72669 8.7914 12.1635ZM16.2253 19.0476C14.2188 21.1408 11.0003 21.3162 9.03455 19.4358C7.06685 17.5522 7.10049 14.326 9.10767 12.2302C11.1142 10.1337 14.3353 9.96223 16.2997 11.8419C18.2668 13.7242 18.2338 16.9492 16.2253 19.0476Z",
    fill: "#F37C4B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3925_20232",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 20,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.64746H20.0141V18.4484H1V2.64746Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3925_20232)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12942 5.66116C0.801239 9.08863 -0.301349 14.0574 2.66606 16.7556C5.63736 19.4532 11.5547 18.8637 15.8855 15.4356C20.2143 12.0075 21.3156 7.0394 18.3462 4.34181C15.3762 1.64098 9.45889 2.23304 5.12942 5.66116ZM9.00524 4.31854C13.1775 2.75395 17.3044 4.33731 18.2206 7.85213C19.1382 11.3663 16.5001 15.4861 12.3279 17.0494C8.15435 18.6147 4.02935 17.03 3.10988 13.5158C2.19235 9.99972 4.83171 5.88184 9.00524 4.31854Z",
    fill: "#F05A28"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/한화투자증권-24.2d92b8d166f3f1823cd6f4518894e4f5.svg";
export { ForwardRef as ReactComponent };